var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h2',[_vm._v("旭德简介")]),(_vm.aboutText.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.aboutText.content)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }